// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root___sss3","range":"MonthRangeSwitch_range__FYzNp","disabled":"MonthRangeSwitch_disabled__1H8N4"};